import { errHof, httpDelete, httpGet, httpPost } from "@/http"
import { createAsyncThunk } from "@reduxjs/toolkit"

/** @typedef {import("@/types").ClassNote} ConstituentClassNote */

export const fetchClassNotesThunk = createAsyncThunk(
  "classNote/admin/fetchClassNotes",
  async (_, { rejectWithValue, signal }) => {
    try {
      /** @type {ConstituentClassNote[]} */
      const data = await httpGet(
        "admin/classNote",
        {},
        {
          signal,
          error: errHof(rejectWithValue, "fetchClassNotes"),
        },
      )

      return data
    } catch (err) {
      rejectWithValue(err)
    }
  },
)

export const exportClassNotesThunk = createAsyncThunk(
  "classNote/admin/exportClassNotes",
  /** @returns {null} */
  async ({ onSuccess, onError, data }, { rejectWithValue, signal }) => {
    try {
      await httpPost("admin/classNote", data, {
        signal,
        success: onSuccess,
        error: errHof(onError, "exportClassNotes", rejectWithValue),
      })

      return null
    } catch (err) {
      rejectWithValue(err)
    }
  },
)

export const deleteClassNoteThunk = createAsyncThunk(
  "classNote/admin/deleteClassNote",
  async ({ onSuccess, onError, classNoteId }, { rejectWithValue, signal }) => {
    try {
      /** @type {ConstituentClassNote[]} */
      const data = await httpDelete(
        `admin/classNote/${classNoteId}`,
        {},
        {
          signal,
          success: onSuccess,
          error: errHof(onError, "deleteClassNote", rejectWithValue),
        },
      )

      return data
    } catch (err) {
      rejectWithValue(err)
    }
  },
)
